import {
  Button,
  Theme,
  createStyles,
  makeStyles,
  Tooltip,
} from '@material-ui/core';
import React, { useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useEadTreeContext } from './EadTreeCtx';
import { useBulkExpand } from './grid-ctx-hook';
import { useVariantContext } from './VariantCtx';
import { useClearContext } from './useProcessParams';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    expandButton: {
      minWidth: 40,
      marginRight: 8,
      color: '#a3a3a3',
      borderColor: '#a3a3a3',
      '&:hover': {
        border: '1px solid white',
        color: 'white',
      },
      '&:disabled': {
        border: '1px dashed grey',
        borderColor: 'grey',
        color: 'grey',
        '&:hover': {
          cursor: 'not-allowed',
        },
      },
    },
    tooltip: {
      fontSize: 12,
    },
  })
);

const BulkExpandButtons = () => {
  const { level, ead } = useParams<{ level: string; ead: string }>();
  const levelInt = parseInt(level);
  const { handleExpandMode, handleCollapseAllNodes } = useBulkExpand();
  const classes = useStyles();
  const ectx = useEadTreeContext();
  const variant = useVariantContext();
  const clearContext = useClearContext();
  const { nextIdsToExpand, currentArchivalAid, expandedNodesIdsHEAP } = ectx;
  const isEad = ead === 'ead';
  const collapsable = useMemo(
    () =>
      Object.keys(expandedNodesIdsHEAP ?? {}).some(
        (k) => expandedNodesIdsHEAP?.[k]
      ),
    [expandedNodesIdsHEAP]
  );
  const baseLevel = variant === 'funds' ? 0 : 1;
  if (!isEad && (!currentArchivalAid || levelInt <= baseLevel)) {
    return <></>;
  }
  // const linkBack = `/${variantToPath[variant!]}/0/${
  //   ectx.currentArchivalAid?.archivalCollection?.id ?? ''
  // }`;

  const linkBack =
    variant === 'funds'
      ? `/fondy/0/${ectx.currentArchivalAid?.archivalCollection?.id ?? ''}`
      : `/pomucky/0/${ectx.currentArchivalAid?.id ?? ''}`;

  return (
    <div
      style={{
        padding: '0 16px',
        lineHeight: '60px',
        height: 60,
        maxHeight: 60,
      }}
    >
      <Link to={linkBack} onClick={clearContext}>
        <Tooltip
          title={
            <span className={classes.tooltip}>
              Zpět na {variant === 'funds' ? 'fondy' : 'pomůcky'}
            </span>
          }
          placement="top"
        >
          <Button
            size="small"
            variant="outlined"
            className={classes.expandButton}
          >
            Zpět na {variant === 'funds' ? 'fondy' : 'pomůcky'}
          </Button>
        </Tooltip>
      </Link>
      <Tooltip
        title={<span className={classes.tooltip}>Sbalit vše</span>}
        placement="top"
      >
        <Button
          variant="outlined"
          disabled={!collapsable}
          onClick={handleCollapseAllNodes}
          size="small"
          className={classes.expandButton}
        >
          -
        </Button>
      </Tooltip>
      <Tooltip
        title={<span className={classes.tooltip}>Rozbalit úroveň</span>}
        placement="top"
      >
        <Button
          onClick={handleExpandMode}
          variant="outlined"
          disabled={(nextIdsToExpand?.length ?? 0) === 0}
          className={classes.expandButton}
          size="small"
        >
          +
        </Button>
      </Tooltip>
    </div>
  );
};

export default BulkExpandButtons;
